import { render, staticRenderFns } from "./landAdd.vue?vue&type=template&id=09fd9114&scoped=true"
import script from "./landAdd.vue?vue&type=script&lang=js"
export * from "./landAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd9114",
  null
  
)

export default component.exports